import helper from "@/api/helper";
import rpc from "@/api/rpc";
import Vue from "vue";
import { Plugin } from "vue-fragment";
import App from "./App.vue";
import router from "./router";
import OneSignalVue from "onesignal-vue";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyDqX9eCXmQJur8IhqWzlC1ftBDwxa-8_aw",
  authDomain: "browseit-461d3.firebaseapp.com",
  projectId: "browseit-461d3",
  storageBucket: "browseit-461d3.firebasestorage.app",
  messagingSenderId: "8201375456",
  appId: "1:8201375456:web:b318cb36d18c1cef060a85",
  measurementId: "G-NFFWBSY3SD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);

Vue.use(Plugin);
Vue.use(OneSignalVue);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Browseit";
  next();
});

// OneSignal initialization function
async function initializeOneSignal() {
  try {
    await Vue.prototype.$OneSignal.init({
      appId: "5426d7a4-a8fb-49e1-9d2e-82e8a76f1075",
      serviceWorkerPath: "/OneSignalSDKWorker.js",
      serviceWorkerParam: { scope: "/" },
      allowLocalhostAsSecureOrigin: true,
      notifyButton: {
        enable: true,
        size: "small",
        position: "bottom-left",
        showCredit: false
      },
      promptOptions: {
        slidedown: {
          enabled: true,
          autoPrompt: false,
          timeDelay: 10,
          pageViews: 3
        }
      }
    });

    console.log("OneSignal initialized successfully");

    // Track notification opens with Firebase
    Vue.prototype.$OneSignal.Notifications.addEventListener("click", event => {
      logEvent("os_notification_opened", {
        notification_id: event.notification.id,
        title: event.notification.title
      });
    });

    // User ID tracking
    Vue.prototype.$OneSignal.User.PushSubscription.addEventListener(
      "change",
      isSubscribed => {
        if (isSubscribed) {
          Vue.prototype.$OneSignal.User.PushSubscription.getId().then(
            userId => {
              helper.set_localstorage_user_data(
                { onesignal_user_id: userId },
                "oneSignalData"
              );
              setUserId(userId);
            }
          );
        }
      }
    );
  } catch (error) {
    console.error("OneSignal initialization failed:", error);
    logEvent("onesignal_init_failed", { error: error.message });
  }
}

new Vue({
  data: {
    apiStatusCode: 0
  },
  watch: {
    async apiStatusCode(val) {
      try {
        let path = "";
        let payload = {},
          token_details = {};
        if ([600, 602].includes(val)) {
          path = "api/v2/get-access-token";
        } else if ([608, 610].includes(val)) {
          path = "api/v2/renew-access-token";
          token_details = helper.get_localstorage_user_data("userInfo") || {};
          let { refresh_token } = token_details;
          payload = { refresh_token };
        }
        const token_response = await rpc.rpc_connector(
          path,
          payload,
          "api_key"
        );
        console.log("token_response:", token_response.data);
        const { status_code } = token_response.data;
        if (status_code === 200) {
          const {
            access_token,
            refresh_token,
            access_token_expiry_time_in_sec
          } = token_response.data;
          const userInfo = {
            ...token_details,
            access_token,
            refresh_token,
            valid_till: access_token_expiry_time_in_sec
          };
          helper.set_localstorage_user_data(userInfo);
          return location.reload();
        } else {
          helper.remove_user_data_from_localstorage("userInfo");
          return true;
        }
      } catch (error) {
        console.error("Error handling token refresh:", error);
        helper.remove_user_data_from_localstorage("userInfo");
        return true;
      }
    }
  },
  router,
  render: h => h(App),
  async beforeMount() {
    await initializeOneSignal();
  }
}).$mount("#app");
